// Global SWR fetcher utility
export const fetcher = async (url: string) => {
  const res = await fetch(url);
  if (!res.ok) {
    const error = new Error('An error occurred while fetching data.');
    throw error;
  }
  return res.json();
};

export const swrOptions = {
  revalidateOnFocus: false, // Don't aggressively refetch on window focus
  dedupingInterval: 5000,    // Dedupe requests within 5 seconds
  revalidateIfStale: true,
};
